import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

interface Props {
    cls: string;
    label: string;
    labelId: string;
    value: string | number;
    items: { id: number | string; description: string }[];
    onChange: (e: any) => void;
    includeNoneOption?: boolean; // Новый пропс для включения/выключения опции "Не выбрано"
}

export const CustomSelect = ({ cls, label, labelId, value, items, onChange, includeNoneOption = true  }: Props) => {
    return (
        <FormControl className={cls} variant="outlined">
            <InputLabel id={`${labelId}-label`}>{label}</InputLabel>
            <Select
                labelId={`${labelId}-label`}
                id={labelId}
                value={value}
                label={label}
                onChange={onChange}
            >
                {includeNoneOption && (
                    <MenuItem value="">
                        <em>Не выбрано</em>
                    </MenuItem>
                )}
                {items.map((item: any, index: any) => (
                    <MenuItem key={index} value={item.id}>
                        {item.description}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};
